import React, { ReactNode } from "react";
import useUuid from "../../../hooks/uuid-hook";
import "./checkbox.scss";

export interface ICheckboxProps {
    label: ReactNode;
    checked?: boolean;
    size?: CHECKBOX_SIZES;
    onChange?(checked: boolean): void;
    disabled?: boolean;
}

export enum CHECKBOX_SIZES {
    SMALL = 'small',
    MEDIUM = 'medium',
}

export const Checkbox: React.FC<ICheckboxProps> = ({ label, checked, onChange = () => { }, size = CHECKBOX_SIZES.MEDIUM, disabled = false }) => {
    const elemId = useUuid();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            onChange(e.target.checked);
        }
    }

    return (
        <div className={`checkbox-block${disabled ? ' disabled' : ''} size-${size}`}>
            <label htmlFor={elemId} onClick={(e) => e.stopPropagation()}>
                <input type="checkbox" disabled={disabled} id={elemId} checked={checked ?? false} onChange={handleChange} />
                <span className="checkbox"></span>{label}
            </label>
        </div>
    );
}
